import { render } from "./RecurringExpense.vue?vue&type=template&id=b8fc2a3a"
import script from "./RecurringExpense.vue?vue&type=script&lang=js"
export * from "./RecurringExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__